import { TelegramAuthRequestDto } from "definitions/poizon-sso";

export const checkTelegramData = (
  data: ITelegramUser,
): TelegramAuthRequestDto => {
  if (typeof data.id !== "number") {
    throw new Error('The "id" field is required and must be a number.');
  }

  if (typeof data.hash !== "string") {
    throw new Error('The "hash" field is required and must be a string.');
  }

  if (typeof data.auth_date !== "number") {
    throw new Error(
      'The "auth_date" field (mapped to "authDate") is required and must be a number.',
    );
  }

  return {
    id: data.id,
    firstName: data.first_name,
    lastName: data.last_name,
    username: data.username,
    photoUrl: data.photo_url,
    authDate: data.auth_date,
    hash: data.hash,
  };
};
